import { taxAxios } from '@/utils/taxAxios';

/** 富民银行授权链接 */
export const getFMAuthorizeUrl = (data) => {
  return taxAxios.post(`/api/dbc/external/taxation/fm/authorizeUrl`, data)
}